<template>
  <div :style="style" class="nav-component-container">
    <button :loading="$common.submitting" @click="$emit('submit')" class="nav-btn" :class="{'nav-btn-round':control.data.data.round&&!control.data.data.circle,'nav-btn-circle':control.data.data.circle,'full-width':control.data.data.fullwidth&&!control.data.data.circle}" style="border:1px solid" :style="{'color':control.data.data.label.color,'background-color':control.data.data.outlined?'#ffffff':control.data.data.btn.color,'border-color':control.data.data.btn.color,'border-width':control.data.data.plain?'0px':'1px'}">
        <span class="iconfont" :class="control.data.data.icon" v-if="control.data.data.icon!=''&&control.data.data.icon_pos==BTN_ICON_POS_LEFT"></span>
        <span :style="{'margin-right:2px':control.data.data.icon_pos==BTN_ICON_POS_RIGHT,'margin-left:2px':control.data.data.icon_pos==BTN_ICON_POS_LEFT}" v-if="!control.data.data.circle">{{control.data.data.label.text}}</span>
        <span class="iconfont" :class="control.data.data.icon" v-if="control.data.data.icon!=''&&control.data.data.icon_pos==BTN_ICON_POS_RIGHT"></span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'SubmitControl',
  data(){
    return {
      style:'',
      BTN_ICON_POS_LEFT:1,
      BTN_ICON_POS_RIGHT:2
    }
  },
  props: {
    control: null
  },
  emits: ['submit'],
  methods:{
      
  },
  updated(){

      

  },
  mounted(){


  },
  created(){
    
    this.style=this.$common.generateStyle(this.control.data.style);


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .nav-component-container{
    text-align: center;
  }

  .nav-btn{
    padding: 0.75rem 1.25rem;
    font-size: 1rem;
    transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
    border-radius: 6px;
    text-align: center;
  }

  .nav-btn-round{
    border-radius: 2rem !important;
  }

  .nav-btn-circle{
    padding: 0.75rem !important;
    border-radius: 50% !important;
  }

  .full-width{
    width: 100%;
  }

</style>